//TODO: load react-i18next from CDN
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Custom language detector to prioritize URL path
const UrlLanguageDetector = {
  name: 'urlDetector',
  lookup(options) {
    // Example: URL = /en/home -> returns "en"
    const path = window.location.pathname;
    const langMatch = path.match(/^\/([a-z]{2})(\/|$)/i);
    if (langMatch && langMatch[1]) return langMatch[1];
    return null;
  },
  cacheUserLanguage() {
    // we won't cache here
  },
};


i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({


    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['urlDetector', 'querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: [], // don't store in cookie/localStorage
    },
    backend: {
        loadPath: '/media/com_kurortlife/js/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

// Register the custom detector
i18n.services.languageDetector.addDetector(UrlLanguageDetector);

export default i18n;